import axios from 'axios';
import React, { useEffect } from 'react';
import CheckBox from '../../Components/CheckBox/CheckBox';
import { Button } from '../../Components/StyledComponents';
import { encrypt } from '../../Utils/functions';
import './Login.scss';
import md5 from 'crypto-js/md5';
import { useNavigate } from 'react-router-dom';
import { alertRef } from '../../App';
import { useChannelIOApi } from 'react-channel-plugin';
import { useDispatch } from 'react-redux';
import { setExpiryDay, setState } from '../../redux/reducers/user';
import moment from 'moment';


const Login = () => {
    const [ id, setId ] = React.useState('');//아이디
    const [ password, setPassword ] = React.useState('');//패스워드
    const [ saveId, setSaveId ] = React.useState(false)//아이디 저장 여부
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const { showMessenger } = useChannelIOApi();
    


    useEffect(() => {
        let id = localStorage.getItem('id')
        if( id !== null ){
            setId(id)
            setSaveId(true)
        }
    },[])

    function getToday(){
        var date = new Date();
        var year = date.getFullYear();
        var month = ("0" + (1 + date.getMonth())).slice(-2);
        var day = ("0" + date.getDate()).slice(-2);
    
        return year + "-" + month + "-" + day;
    }

    const login = () => {
        let encInfo = encrypt(JSON.stringify({ id : id, password : md5(password).toString() }))
        axios.post('/api/login',{ Payload : encInfo })
        .then((data) => {
                if(saveId) localStorage.setItem('id',id)
                localStorage.setItem('storeName',data.data.Name)
                /* dispatch(setState(data.data.State))
                dispatch(setExpiryDay(moment(data.data.ExpiryDate.$date).utc().diff(moment(getToday()),'days')) )
                if(data.data.State === 'Stop')navigate('/expire',{ state : { expiry : data.data.ExpiryDate.$date }})
                else  */navigate('/stats')
            }
        )
        .catch(() => {
            alertRef.current.showAlert({ title : `아이디 혹은 비밀번호를 확인해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    return(
        <div className='login'>
            <div className='top-banner row'>
                <p className='new-text'>아직 시럽프렌즈를 사용하고 계시지 않으신가요?</p>
                <button className='req-chat-btn' onClick={showMessenger}>
                    <p className='req-chat'>가맹 문의하기</p>
                </button>
            </div>
            <div className='login-box'>
                <p className='logo'>Syrup Friends</p>
                <div className='row'>
                    <p className='title' style={{ marginBottom : 0 }}>시럽프렌즈 사장님광장</p>
                    <p className='title-black'>&nbsp;로그인</p>
                </div>

                <div style={{ display: 'flex', flexDirection : 'column' }}>
                    <label className='label' htmlFor='id'>아이디</label>
                    <input 
                        id="id"
                        value={id}
                        onChange={(e) => setId(e.target.value)}
                        placeholder='아이디를 입력해주세요.'
                    ></input>
                </div>

                <div style={{ display: 'flex', flexDirection : 'column', marginTop : 24, marginBottom : 30 }}>
                    <label className='label' htmlFor='password'>비밀번호</label>
                    <input 
                        id="password"
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder='비밀번호를 입력해주세요.'
                        type={'password'}
                        onSubmit={() => login()}
                        onKeyUp={(e) => {if(e.key === 'Enter')login()}}
                    ></input>
                </div>

                <CheckBox checked={saveId} label={'아이디 저장하기'} onChange={() => setSaveId(!saveId)}/>

                <div style={{ display : 'flex', justifyContent : 'center'}}>
                    <Button variant={'main'} style={{ width : 156, alignSelf : 'center', marginTop : 80 }} onClick={() => login()}>
                        로그인하기
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default Login;